import {
  OrgaPortalFeatureDeviceService,
  OrgaPortalFeaturePingService
} from './services';
import {deviceDetailStore, deviceListStore, devicePingListStore} from './stores';

export * from './services';
export * from './stores';

export * from './devices.state';
export * from './devices.selectors';

export const devicesReducers = {
  deviceList: deviceListStore.reducer,
  deviceDetail: deviceDetailStore.reducer,
  devicePingList: devicePingListStore.reducer
};

export const devicesEffects = [
  deviceListStore.effects,
  deviceDetailStore.effects,
  devicePingListStore.effects
];

export const devicesServices = [
  OrgaPortalFeatureDeviceService,
  OrgaPortalFeaturePingService
];
